import { render, staticRenderFns } from "./NotificationsFixedAndFunctionClick.vue?vue&type=template&id=ffcc79e6&"
import script from "./NotificationsFixedAndFunctionClick.vue?vue&type=script&lang=js&"
export * from "./NotificationsFixedAndFunctionClick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports